;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface FoodIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function FoodIcon({ size = 24, ...props }: FoodIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2 12.2778C2 12.95 2.54 13.5 3.2 13.5H12.8C13.46 13.5 14 12.95 14 12.2778V10.4444H2V12.2778ZM3.2 11.6667H12.8V12.2778H3.2V11.6667Z"
        fill="currentColor"
      />
      <path
        d="M11.996 7.69444C10.826 7.69444 10.742 8.30556 9.99797 8.30556C9.28397 8.30556 9.14598 7.69444 7.99998 7.69444C6.82998 7.69444 6.74598 8.30556 6.00199 8.30556C5.28799 8.30556 5.14999 7.69444 4.00399 7.69444C2.834 7.69444 2.75 8.30556 2.006 8.30556V9.52778C3.146 9.52778 3.308 8.91667 4.01599 8.91667C4.72999 8.91667 4.86799 9.52778 6.01399 9.52778C7.18398 9.52778 7.26798 8.91667 8.01198 8.91667C8.72598 8.91667 8.86398 9.52778 10.01 9.52778C11.18 9.52778 11.264 8.91667 12.008 8.91667C12.722 8.91667 12.848 9.51556 14 9.52778L13.994 8.31778C13.028 8.11611 13.022 7.69444 11.996 7.69444Z"
        fill="currentColor"
      />
      <path
        d="M14 6.16667C14.012 3.72222 11.432 2.5 7.99998 2.5C4.57399 2.5 2 3.72222 2 6.16667V6.77778H14V6.16667ZM3.308 5.55556C3.80599 4.21722 5.96599 3.72222 7.99998 3.72222C9.98597 3.72222 11.558 4.16833 12.314 4.93833C12.494 5.12778 12.626 5.32944 12.704 5.55556H3.308Z"
        fill="currentColor"
      />
    </svg>
  );
}
